<template>
  <component :is="catalogs"></component>
</template>

<script>
import InternalCatalogs from "./InternalCatalogs";
import CustomerCatalogs from "./CustomerCatalogs";

export default {
  components: {
    InternalCatalogs,
    CustomerCatalogs
  },
  computed: {
    catalogs() {
      return this.$store.getters.user.userInfo.type === "C"
        ? CustomerCatalogs
        : InternalCatalogs;
    }
  }
};
</script>
